
import 'lazysizes';
import Url from 'domurl';
import debounce from 'lodash/debounce';
import inView from 'in-view/src/in-view.js';

class Images {

    constructor() {

        $(document).on( 'lazybeforeunveil', this.unveil.bind(this) );
        $(window).on( 'resize', debounce( this.resize.bind(this), 500 ) );

        inView.threshold(0.75);
        inView('[data-inview]')
            .on('enter', el => {
                el.classList.add('is-visible');
            });

    }

    unveil( e ) {

        e.preventDefault();

        const $image = $(e.target);
        const $parent = $image.parent();
        const src = this.getResizedSrc( $image );

        if ( !src )
            return;

        $image.attr( 'src', src );
        $parent.addClass( 'is-loading' );

        $image.one( 'load', () => {
            $parent.removeClass( 'is-loading' ).addClass( 'is-loaded' );
        } );

        if ( $image[0].complete )
            $image.trigger('load');

    }

    resize() {

        $('.lazyloaded').each( ( index, elem ) => {

            const $image = $(elem);
            const src = this.getResizedSrc( $image );

            if ( !src )
                return;

            $image.attr( 'src', src );

        } );

    }

    getResizedSrc( $image ) {

        const src = $image.data('src');
        const imageWidthThreshold = 200;

        if ( !src || !$image.is(':visible') )
            return null;

        const parentElem = $image[0].parentElement;

        const elemWidth = parentElem.clientWidth;
        const elemHeight = parentElem.clientHeight;
        const elemAspect = elemHeight / elemWidth;

        const width = Math.ceil( elemWidth / imageWidthThreshold) * imageWidthThreshold;
        const height = Math.ceil( width * elemAspect );

        let url = new Url( src );
        url.query.w = width;
        url.query.h = height;
        url.query.dpr = window.devicePixelRatio;

        return url.toString();

    }

}

new Images();